module.exports = "<ul class=\"ui-select-no-choice dropdown-menu\"\n    ng-show=\"$select.items.length == 0\">\n    <li ng-transclude>\n\n    </li>\n</ul>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/third/ui-select/src/bootstrap/no-choice.tpl.html
// module id = 466
// module chunks = 0